import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HeroSection from "./pages/HeroSection";
import ServicesSection from "./pages/ServicesSection";
import AboutSection from "./pages/AboutSection";
import TechnologySection from "./pages/TechnologySection";
import ScansDetailSection from "./pages/ScansDetailSection";
import FacilitiesSection from "./pages/FacilitiesSection";
import AppointmentSection from "./pages/AppointmentSection";
import ContactSection from "./pages/ContactSection";

function App() {
  return (
    <div className="min-h-screen font-sans antialiased">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <FacilitiesSection />
        <ScansDetailSection />
        <AboutSection />
        <TechnologySection />
        <AppointmentSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
